import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { UpsellToggleCardComponent } from '@core/components/upsell-toggle-card/upsell-toggle-card.component';
import { TransactionWrapper, Upsell } from '@core/models';

@Component({
  selector: 'app-group-outing',
  imports: [CommonModule, UpsellToggleCardComponent],
  templateUrl: './group-outing.component.html',
  styleUrl: './group-outing.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupOutingComponent {
  @Output() changeUpsell = new EventEmitter<HTMLInputElement>();
  totalTransactionSeats = input.required<number>();
  transaction = input.required<TransactionWrapper>();
  upsellSelected = input.required<Upsell | null>();
  discountActive = input<boolean>(false);

  isUpsellDisabled(upsell: Upsell): boolean {
    return this.discountActive() && upsell.editable === false;
  }

  onChangeUpsell(radio: HTMLInputElement) {
    this.changeUpsell.emit(radio);
  }
}
